module.exports = __webpack_public_path__ + "static/img/speed.a6a457e6.svg";